/* CENIT · Header, menú y carrito lateral. Antes vivía dentro de sections/cenit-header.liquid. */
(function(){

  function cenitRoot(){
    return (
      window.Shopify &&
      Shopify.routes &&
      Shopify.routes.root
    )
      ? Shopify.routes.root
      : '/';
  }


  function cenitHeaderMoney(cents){

    return new Intl.NumberFormat(
      'es-MX',
      {
        style:'currency',
        currency:'MXN'
      }
    ).format(
      (cents || 0) / 100
    );

  }


  /* Descuentos del carrito con su nombre real. Solo el descuento automático cuyo nombre contiene el texto
     de "Nombre del descuento automático del 3x2" se llama "Tu 3x2" (Shopify a veces manda el tipo vacío, por eso
     cuenta cualquier descuento que no sea código); los códigos aparecen como "Código CENIT10".
     Misma regla que snippets/cenit-cart-descuentos.liquid. */
  function cenitDiscountLabel(app){
    var box = document.getElementById('cenitCartDiscounts');
    var title = String((app && app.title) || '').trim();
    var x32Title = box ? String(box.getAttribute('data-x32-title') || '') : '';
    if(box && box.getAttribute('data-x32') === '1' && app && app.type !== 'discount_code' && x32Title && title.toLowerCase().indexOf(x32Title) > -1){
      return 'Tu 3x2';
    }
    var welcome = box ? String(box.getAttribute('data-welcome-code') || '') : '';
    if(app && app.type === 'discount_code' && welcome && title.toUpperCase() === welcome){
      return 'Bienvenida ' + (box.getAttribute('data-welcome-pct') || '') + '% · ' + title;
    }
    if(app && app.type === 'discount_code') return 'Código ' + title;
    return title || 'Descuento';
  }

  /* Junta los descuentos del carrito (de pedido y de línea) en una lista: [{ app, amount }] */
  function cenitCartDiscounts(cart){
    var byKey = {};
    var list = [];
    function add(app, amount){
      amount = Number(amount) || 0;
      if(!app || amount <= 0) return;
      var key = (app.type || '') + '|' + (app.title || '');
      if(!byKey[key]){
        byKey[key] = { app: app, amount: 0 };
        list.push(byKey[key]);
      }
      byKey[key].amount += amount;
    }
    /* /cart.js manda la aplicación plana; /cart/update.js la manda envuelta en { amount, discount_application } */
    (cart.cart_level_discount_applications || []).forEach(function(app){
      if(app && app.discount_application) add(app.discount_application, app.amount);
      else add(app, app && app.total_allocated_amount);
    });
    (cart.items || []).forEach(function(item){
      (item.line_level_discount_allocations || []).forEach(function(al){
        add(al.discount_application, al.amount);
      });
    });
    return list;
  }

  function cenitRenderDiscounts(cart){
    var box = document.getElementById('cenitCartDiscounts');
    if(!box || !cart) return;
    var rows = cenitCartDiscounts(cart);
    box.hidden = !rows.length;
    box.innerHTML = rows.map(function(row){
      return '<div class="cenit-cart-drawer__saved" data-discount-type="' + cenitEscapeHtml(row.app.type || '') + '">' +
        '<span>' + cenitEscapeHtml(cenitDiscountLabel(row.app)) + '</span>' +
        '<strong>−' + cenitHeaderMoney(row.amount) + '</strong>' +
      '</div>';
    }).join('');
  }


  /* Precio de una línea del carrito: marca las piezas gratis (con "3x2" solo si las regaló el 3x2) */
  function cenitLinePrice(item){
    var fin = typeof item.final_line_price === 'number' ? item.final_line_price : (item.line_price || 0);
    var orig = item.original_line_price || 0;
    if(fin === 0 && orig > 0){
      var by3x2 = (item.line_level_discount_allocations || []).some(function(al){
        return cenitDiscountLabel(al.discount_application) === 'Tu 3x2';
      });
      return '<span class="cenit-cart-drawer__gift">' + (by3x2 ? 'Gratis · 3x2' : 'Gratis') + '</span> <s>' + cenitHeaderMoney(orig) + '</s>';
    }
    if(fin < orig){
      return '<span>' + cenitHeaderMoney(fin) + '</span> <s>' + cenitHeaderMoney(orig) + '</s>';
    }
    return '<span>' + cenitHeaderMoney(fin) + '</span>';
  }


  function cenitHeaderMoneyCompact(cents){

    return new Intl.NumberFormat(
      'es-MX',
      {
        style:'currency',
        currency:'MXN',
        maximumFractionDigits:0
      }
    ).format(
      (cents || 0) / 100
    );

  }


  function cenitEscapeHtml(value){

    return String(
      value == null
        ? ''
        : value
    )
    .replace(/&/g,'&amp;')
    .replace(/</g,'&lt;')
    .replace(/>/g,'&gt;')
    .replace(/"/g,'&quot;')
    .replace(/'/g,'&#039;');

  }


  function cenitCartImageUrl(url){

    if(!url){
      return '';
    }

    try{
      var u = new URL(url, window.location.origin);
      u.searchParams.set('width','600');
      return u.toString();
    }catch(e){
      return url;
    }

  }


  function cenitFetchCart(){

    return fetch(
      cenitRoot() + 'cart.js',
      {
        headers:{
          'Accept':'application/json'
        }
      }
    )
    .then(
      function(response){

        if(!response.ok){
          throw new Error(
            'No se pudo cargar el carrito.'
          );
        }

        return response.json();

      }
    );

  }



  /* ========================================================
     BUSCADOR PREDICTIVO
  ======================================================== */

  var cenitSearchTimer = null;
  var cenitSearchController = null;

  function cenitSearchMoney(cents){
    return new Intl.NumberFormat('es-MX',{
      style:'currency',
      currency:'MXN',
      maximumFractionDigits:0
    }).format((Number(cents) || 0) / 100);
  }

  function cenitSearchProductCard(product){
    var title = cenitEscapeHtml(product.title || '');
    var url = cenitEscapeHtml(product.url || '#');
    var imageUrl = '';

    if(product.featured_image && product.featured_image.url){
      imageUrl = product.featured_image.url;
    }else if(product.image){
      imageUrl = product.image;
    }

    if(imageUrl){
      try{
        var u = new URL(imageUrl, window.location.origin);
        u.searchParams.set('width','640');
        imageUrl = u.toString();
      }catch(e){}
    }

    return (
      '<a class="cenit-search-product" href="' + url + '">' +
        '<div class="cenit-search-product__media">' +
          (imageUrl
            ? '<img src="' + cenitEscapeHtml(imageUrl) + '" alt="' + title + '" loading="lazy" decoding="async">'
            : '') +
        '</div>' +
        '<div class="cenit-search-product__body">' +
          '<span class="cenit-search-product__name">' + title + '</span>' +
          '<span class="cenit-search-product__price">' + cenitSearchMoney(product.price) + ' MXN</span>' +
        '</div>' +
      '</a>'
    );
  }

  function cenitRenderSearchLoading(){
    var body = document.getElementById('cenitSearchBody');
    if(body){
      body.innerHTML = '<div class="cenit-search-state"><span class="cenit-search-spinner" aria-hidden="true"></span></div>';
    }
  }

  function cenitRenderSearchResults(query, products){
    var body = document.getElementById('cenitSearchBody');
    if(!body) return;

    if(!products || !products.length){
      body.innerHTML =
        '<div class="cenit-search-state">No encontramos resultados para “' +
        cenitEscapeHtml(query) +
        '”.</div>';
      return;
    }

    body.innerHTML =
      '<div class="cenit-search-results-head">' +
        '<h3>Resultados</h3>' +
        '<span>' + products.length + (products.length === 1 ? ' pieza' : ' piezas') + '</span>' +
      '</div>' +
      '<div class="cenit-search-grid">' +
        products.map(cenitSearchProductCard).join('') +
      '</div>' +
      '<a class="cenit-search-all" href="/search?q=' + encodeURIComponent(query) + '">' +
        'Ver todos los resultados <span>→</span>' +
      '</a>';
  }

  function cenitPredictiveSearch(query){
    query = String(query || '').trim();

    var clear = document.getElementById('cenitSearchClear');
    if(clear) clear.classList.toggle('visible', query.length > 0);

    if(query.length < 2){
      if(cenitSearchController) cenitSearchController.abort();

      var body = document.getElementById('cenitSearchBody');
      if(body){
        body.innerHTML =
          '<div class="cenit-search-state">Escribe al menos 2 letras para buscar.</div>';
      }
      return;
    }

    cenitRenderSearchLoading();

    if(cenitSearchController) cenitSearchController.abort();
    cenitSearchController = new AbortController();

    var url =
      cenitRoot() +
      'search/suggest.json?q=' +
      encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';

    fetch(url,{
      headers:{'Accept':'application/json'},
      signal:cenitSearchController.signal
    })
    .then(function(response){
      if(!response.ok) throw new Error('No se pudo buscar.');
      return response.json();
    })
    .then(function(data){
      var products =
        data &&
        data.resources &&
        data.resources.results &&
        data.resources.results.products
          ? data.resources.results.products
          : [];

      cenitRenderSearchResults(query, products);
    })
    .catch(function(error){
      if(error && error.name === 'AbortError') return;

      var body = document.getElementById('cenitSearchBody');
      if(body){
        body.innerHTML =
          '<div class="cenit-search-state">No pudimos cargar la búsqueda. Intenta de nuevo.</div>';
      }
    });
  }

  window.cenitOpenSearch = function(){
    if(typeof window.cenitCloseDrawer === 'function') window.cenitCloseDrawer();
    if(typeof window.cenitCloseAccountMenu === 'function') window.cenitCloseAccountMenu();

    var overlay = document.getElementById('cenitSearchOverlay');
    var input = document.getElementById('cenitSearchInput');
    var trigger = document.querySelector('.cenit-header__search-btn');

    if(!overlay) return;

    overlay.classList.add('open');
    overlay.setAttribute('aria-hidden','false');
    if(trigger) trigger.setAttribute('aria-expanded','true');
    document.body.style.overflow = 'hidden';

    if(input && !input.value.trim()) cenitSearchIdle();

    setTimeout(function(){
      if(input) input.focus();
    },180);
  };

  window.cenitCloseSearch = function(){
    var overlay = document.getElementById('cenitSearchOverlay');
    var trigger = document.querySelector('.cenit-header__search-btn');

    if(!overlay) return;

    overlay.classList.remove('open');
    overlay.setAttribute('aria-hidden','true');
    if(trigger) trigger.setAttribute('aria-expanded','false');
    document.body.style.overflow = '';
  };

  window.cenitSearchOverlayClick = function(event){
    if(event.target && event.target.id === 'cenitSearchOverlay'){
      window.cenitCloseSearch();
    }
  };

  window.cenitClearSearch = function(){
    var input = document.getElementById('cenitSearchInput');
    var body = document.getElementById('cenitSearchBody');
    var clear = document.getElementById('cenitSearchClear');

    if(input){
      input.value = '';
      input.focus();
    }
    if(clear) clear.classList.remove('visible');
    if(body){
      body.innerHTML =
        '<div class="cenit-search-state">Busca por nombre, color, tipo de pieza o constelación.</div>';
    }
    cenitSearchIdle();
  };

  function cenitInitSearch(){
    var input = document.getElementById('cenitSearchInput');

    if(!input || input.dataset.cenitReady === '1') return;

    input.dataset.cenitReady = '1';

    input.addEventListener('input',function(){
      var value = input.value;

      if(cenitSearchTimer) clearTimeout(cenitSearchTimer);

      cenitSearchTimer = setTimeout(function(){
        cenitRunSearch(value);
      },140);
    });

    var form = input.closest('form');
    if(form){
      form.addEventListener('submit',function(event){
        var smart = window.cenitSmartSearch;
        var target = smart ? smart.submitUrl(input.value.trim()) : null;
        if(target){
          event.preventDefault();
          window.location.href = target;
        }
      });
    }

    var body = document.getElementById('cenitSearchBody');
    if(body){
      body.addEventListener('click',function(event){
        var chip = event.target.closest('[data-cs-q]');
        if(!chip) return;
        input.value = chip.getAttribute('data-cs-q');
        cenitRunSearch(input.value);
        input.focus();
      });
    }
  }

  /* Buscador CENIT (assets/cenit-search.js); si su índice no carga, usa la búsqueda predictiva de Shopify */
  function cenitSmartReady(){
    var smart = window.cenitSmartSearch;
    if(!smart) return null;
    if(!smart.configured){
      smart.configure(document.getElementById('cenitSearchOverlay'));
      smart.configured = true;
    }
    return smart;
  }

  function cenitSearchIdle(){
    var body = document.getElementById('cenitSearchBody');
    var smart = cenitSmartReady();
    if(!body || !smart) return;
    smart.idle(body).catch(function(){});
  }

  function cenitRunSearch(value){
    var query = String(value || '').trim();
    var clear = document.getElementById('cenitSearchClear');
    var body = document.getElementById('cenitSearchBody');
    var smart = cenitSmartReady();

    if(clear) clear.classList.toggle('visible', query.length > 0);
    if(!smart){
      cenitPredictiveSearch(query);
      return;
    }
    if(!query){
      cenitSearchIdle();
      return;
    }
    smart.query(query, body).catch(function(){
      cenitPredictiveSearch(query);
    });
  }


  /* ========================================================
     MOUNT DRAWERS A BODY
  ======================================================== */

  function cenitMountDrawer(){

    var drawer =
      document.getElementById(
        'cenitDrawer'
      );

    var overlay =
      document.getElementById(
        'cenitOverlay'
      );


    if(
      !drawer ||
      !overlay
    ){
      return;
    }


    if(
      overlay.parentElement !==
      document.body
    ){
      document.body.appendChild(
        overlay
      );
    }


    if(
      drawer.parentElement !==
      document.body
    ){
      document.body.appendChild(
        drawer
      );
    }

  }


  function cenitMountAccountMenu(){

    var menu =
      document.getElementById(
        'cenitAccountMenu'
      );

    var overlay =
      document.getElementById(
        'cenitAccountOverlay'
      );


    if(
      !menu ||
      !overlay
    ){
      return;
    }


    if(
      overlay.parentElement !==
      document.body
    ){
      document.body.appendChild(
        overlay
      );
    }


    if(
      menu.parentElement !==
      document.body
    ){
      document.body.appendChild(
        menu
      );
    }

  }


  /* ========================================================
     OPEN / CLOSE
  ======================================================== */

  /* Menú móvil: se abre debajo de la barra y el header; la hamburguesa se vuelve X */
  function cenitDrawerState(open){
    var btn = document.querySelector('.cenit-header__hamburger');
    if(btn){
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
    }
    var head = document.querySelector('.cenit-header-wrapper');
    if(head) document.documentElement.style.setProperty('--ce-head', Math.round(head.getBoundingClientRect().bottom) + 'px');
  }
  window.cenitToggleDrawer = function(){
    var drawer = document.getElementById('cenitDrawer');
    if(drawer && drawer.classList.contains('open')) window.cenitCloseDrawer();
    else window.cenitOpenDrawer();
  };
  document.addEventListener('keydown', function(e){
    var drawer = document.getElementById('cenitDrawer');
    if(e.key === 'Escape' && drawer && drawer.classList.contains('open')){
      window.cenitCloseDrawer();
      var btn = document.querySelector('.cenit-header__hamburger');
      if(btn) btn.focus();
    }
  });

  window.cenitOpenDrawer =
    function(){

      cenitMountDrawer();

      if(
        typeof window.cenitCloseAccountMenu ===
        'function'
      ){
        window.cenitCloseAccountMenu();
      }


      var drawer =
        document.getElementById(
          'cenitDrawer'
        );

      var overlay =
        document.getElementById(
          'cenitOverlay'
        );


      if(
        !drawer ||
        !overlay
      ){
        return;
      }


      cenitDrawerState(true);

      drawer.classList.add(
        'open'
      );

      overlay.classList.add(
        'open'
      );

      document.body.style.overflow =
        'hidden';

    };


  window.cenitCloseDrawer =
    function(){

      var drawer =
        document.getElementById(
          'cenitDrawer'
        );

      var overlay =
        document.getElementById(
          'cenitOverlay'
        );


      if(
        !drawer ||
        !overlay
      ){
        return;
      }


      cenitDrawerState(false);

      drawer.classList.remove(
        'open'
      );

      overlay.classList.remove(
        'open'
      );

      document.body.style.overflow =
        '';

    };


  window.cenitOpenAccountMenu =
    function(){

      cenitMountAccountMenu();

      if(
        typeof window.cenitCloseDrawer ===
        'function'
      ){
        window.cenitCloseDrawer();
      }


      var menu =
        document.getElementById(
          'cenitAccountMenu'
        );

      var overlay =
        document.getElementById(
          'cenitAccountOverlay'
        );


      if(
        !menu ||
        !overlay
      ){
        return;
      }


      menu.classList.add(
        'open'
      );

      overlay.classList.add(
        'open'
      );

      menu.setAttribute(
        'aria-hidden',
        'false'
      );

      document.body.style.overflow =
        'hidden';


      cenitFetchCart()
      .then(
        function(cart){

          window.cenitUpdateCartHeader(
            cart
          );

        }
      )
      .catch(
        function(error){

          console.error(
            'CENIT: no se pudo actualizar el carrito',
            error
          );

        }
      );

    };


  window.cenitCloseAccountMenu =
    function(){

      var menu =
        document.getElementById(
          'cenitAccountMenu'
        );

      var overlay =
        document.getElementById(
          'cenitAccountOverlay'
        );


      if(
        !menu ||
        !overlay
      ){
        return;
      }


      menu.classList.remove(
        'open'
      );

      overlay.classList.remove(
        'open'
      );

      menu.setAttribute(
        'aria-hidden',
        'true'
      );

      document.body.style.overflow =
        '';

    };


  /* ========================================================
     SHIPPING
  ======================================================== */

  /* Envío gratis: una sola regla para todo el sitio (snippets/cenit-envio-barra.liquid hace lo mismo en Liquid).
     Gratis al llevar el 3x2 (data-envio-piezas) o desde el monto (data-threshold).
     Si falta, dice lo que esté más cerca: la pieza que falta para el 3x2 o el dinero que falta. */
  function cenitShipState(cart, bar){
    var threshold = Number(bar.getAttribute('data-threshold')) || 0;
    var piezas = Number(bar.getAttribute('data-envio-piezas')) || 0;
    var x32On = bar.getAttribute('data-x32') === '1';
    var x32Ship = x32On && piezas === 3;
    var count = Number(cart.item_count) || 0;
    var total = Math.max(0, Number(cart.total_price) || 0);
    var money = cenitHeaderMoneyCompact;
    function pzs(n){ return n === 1 ? '1 pieza más' : n + ' piezas más'; }

    if(count === 0){
      return { pct: 0, done: false, html: x32Ship
        ? '<b>3x2:</b> lleva 3 piezas, la de menor precio va gratis y el envío también'
        : 'Envío gratis desde <b>' + money(threshold) + '</b>' };
    }

    if((piezas > 0 && count >= piezas) || (threshold > 0 && total >= threshold)){
      if(x32On && count >= 3){
        var resto = count % 3;
        return { pct: 100, done: true, html: '<b>3x2 aplicado y envío gratis.</b>' +
          (resto ? ' Agrega ' + pzs(3 - resto) + ' y la de menor precio va gratis' : '') };
      }
      return { pct: 100, done: true, html: '<b>Tu envío es gratis</b>' };
    }

    var moneyLeft = threshold - total;
    if(piezas > 0){
      var left = piezas - count;
      var cheapest = (cart.items || []).reduce(function(min, item){
        var unit = Number(item.final_price || item.price) || 0;
        return unit > 0 && (!min || unit < min) ? unit : min;
      }, 0);
      /* Con el 3x2 la pieza que completa el kit es gratis: solo cuentan las demás */
      var cost = (x32Ship ? left - 1 : left) * cheapest;
      if(threshold <= 0 || cost <= moneyLeft){
        return { pct: count / piezas * 100, done: false, html: 'Agrega <b>' + pzs(left) + '</b>' +
          (x32Ship ? ' y la de menor precio va gratis, con envío incluido' : ' para envío gratis') };
      }
    }

    return { pct: threshold > 0 ? total / threshold * 100 : 0, done: false,
      html: 'Te faltan <b>' + money(moneyLeft) + '</b> para envío gratis' };
  }

  /* Progreso del 3x2: Las Tres Marías se encienden con cada pieza (snippets/cenit-progreso-3x2.liquid) */
  function cenitPaintX32(cart){
    var count = Number(cart.item_count) || 0;
    var rest = count % 3;
    var filled = count > 0 && rest === 0 ? 3 : rest;
    var text = 'Lleva 3 y la de menor precio va gratis, con envío incluido.';
    if(count > 0){
      text = rest === 0
        ? 'Listo: la de menor precio va gratis y el envío también.'
        : 'Agrega ' + (3 - rest) + ' más y la de menor precio va gratis.';
    }
    document.querySelectorAll('[data-cenit-x32]').forEach(function(el){
      el.setAttribute('data-filled', filled);
      var n = el.querySelector('[data-cenit-x32-n]');
      var t = el.querySelector('[data-cenit-x32-text]');
      if(n) n.textContent = filled;
      if(t) t.textContent = text;
    });
  }

  function cenitUpdateShippingProgress(cart){
    if(!cart || !cart.items) return;
    cenitPaintX32(cart);
    document.dispatchEvent(new CustomEvent('cenit:cart-changed', { detail: { cart: cart } }));
    document.querySelectorAll('[data-cenit-shipbar]').forEach(function(bar){
      var state = cenitShipState(cart, bar);
      var fill = bar.querySelector('[data-cenit-ship-fill]');
      var text = bar.querySelector('[data-cenit-ship-text]');
      if(fill) fill.style.width = Math.min(100, state.pct).toFixed(1) + '%';
      if(text) text.innerHTML = state.html;
      bar.classList.toggle('is-complete', state.done);
    });
  }


  /* ========================================================
     ANNOUNCEMENTS
  ======================================================== */

  function cenitInitAnnouncements(){

    var wrap =
      document.querySelector(
        '[data-cenit-announcements]'
      );


    if(
      !wrap ||
      wrap.dataset.cenitReady ===
      '1'
    ){
      return;
    }


    var items =
      Array.prototype.slice.call(
        wrap.querySelectorAll(
          '[data-cenit-announcement]'
        )
      );


    if(!items.length){
      return;
    }


    wrap.dataset.cenitReady =
      '1';


    items.forEach(
      function(item,index){

        item.classList.toggle(
          'is-active',
          index === 0
        );

      }
    );


    if(
      items.length <
      2
    ){
      return;
    }


    if(
      window.matchMedia &&
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
    ){
      return;
    }


    var current =
      0;


    wrap._cenitTimer =
      window.setInterval(
        function(){

          items[current]
          .classList.remove(
            'is-active'
          );


          current =
            (
              current +
              1
            ) %
            items.length;


          items[current]
          .classList.add(
            'is-active'
          );

        },
        4200
      );

  }


  /* ========================================================
     RENDER CART
  ======================================================== */

  function cenitRenderAccountCart(
    cart
  ){

    if(!cart){
      return;
    }


    var itemsEl =
      document.getElementById(
        'cenitAccountCartItems'
      );


    var countEl =
      document.getElementById(
        'cenitAccountCartCount'
      );


    var totalEl =
      document.getElementById(
        'cenitAccountCartTotal'
      );


    var checkoutEl =
      document.getElementById(
        'cenitAccountCheckout'
      );


    var piecesText =
      cart.item_count === 1
        ? 'pieza'
        : 'piezas';


    if(countEl){

      countEl.textContent =
        cart.item_count +
        ' ' +
        piecesText;

    }


    if(totalEl){

      totalEl.textContent =
        cenitHeaderMoney(
          cart.total_price
        );

    }

    /* Un renglón por descuento, con su nombre real */
    cenitRenderDiscounts(cart);

    /* Meses sin intereses sobre el total (layout/theme.liquid: window.cenitMsi) */
    if(window.cenitMsi){
      window.cenitMsi.paint(document.querySelector('.cenit-cart-drawer__msi'), cart.total_price);
    }


    if(checkoutEl){

      if(
        cart.item_count >
        0
      ){

        checkoutEl.classList.remove(
          'is-disabled'
        );

        checkoutEl.removeAttribute(
          'aria-disabled'
        );

      }else{

        checkoutEl.classList.add(
          'is-disabled'
        );

        checkoutEl.setAttribute(
          'aria-disabled',
          'true'
        );

      }

    }


    if(!itemsEl){
      return;
    }


    if(
      !cart.items ||
      !cart.items.length
    ){

      itemsEl.innerHTML =
        '<div class="cenit-cart-drawer__empty">' +
          '<div class="cenit-cart-drawer__empty-icon">✦</div>' +
          '<div class="cenit-cart-drawer__empty-title">Tu cielo todavía está vacío</div>' +
          '<div class="cenit-cart-drawer__empty-text">Elige un anillo, collar o pulsera y aparecerá aquí.</div>' +
        '</div>';

      return;

    }


    itemsEl.innerHTML =
      cart.items.map(
        function(item){

          var title =
            cenitEscapeHtml(
              item.product_title ||
              item.title ||
              ''
            );


          var variant =
            item.variant_title &&
            item.variant_title !==
            'Default Title'
              ? '<div class="cenit-cart-drawer__item-variant">' +
                  cenitEscapeHtml(
                    (item.options_with_values || []).map(function(o){
                      return /size|talla|tamaño/i.test(o.name)
                        ? 'Talla ' + o.value
                        : String(o.value).replace('Blue', 'Azul').replace('Green', 'Verde');
                    }).join(' · ') || item.variant_title
                  ) +
                '</div>'
              : '';


          var image =
            item.image
              ? '<img src="' +
                  cenitEscapeHtml(
                    cenitCartImageUrl(
                      item.image
                    )
                  ) +
                  '" alt="' +
                  title +
                  '" loading="lazy" decoding="async">'
              : '<span class="cenit-cart-drawer__image-empty">✦</span>';


          var itemUrl =
            cenitEscapeHtml(
              item.url ||
              '/cart'
            );


          var itemKey =
            cenitEscapeHtml(
              item.key ||
              ''
            );


          return (
            '<div class="cenit-cart-drawer__item-shell" data-cenit-cart-item data-cart-key="' +
              itemKey +
            '">' +

              '<div class="cenit-cart-drawer__swipe-remove" aria-hidden="true">Quitar</div>' +

              '<a href="' +
                itemUrl +
                '" class="cenit-cart-drawer__item">' +

                '<div class="cenit-cart-drawer__image">' +
                  image +
                '</div>' +

                '<div class="cenit-cart-drawer__item-info">' +

                  '<div class="cenit-cart-drawer__item-kicker">' + (window.cenitKindLabel ? window.cenitKindLabel(item) : 'TU ESTRELLA') + '</div>' +

                  '<div class="cenit-cart-drawer__item-title">' +
                    title +
                  '</div>' +

                  variant +

                  '<div class="cenit-cart-drawer__item-meta">' +
                    cenitLinePrice(item) +
                  '</div>' +

                '</div>' +

              '</a>' +

              '<div class="cenit-cart-drawer__qty" data-cenit-qty-wrap>' +
                '<button type="button" class="cenit-cart-drawer__qty-btn" data-cenit-qty-plus aria-label="Agregar una unidad">+</button>' +
                '<span class="cenit-cart-drawer__qty-value" data-cenit-qty-value>' +
                  Number(item.quantity || 0) +
                '</span>' +
                '<button type="button" class="cenit-cart-drawer__qty-btn" data-cenit-qty-minus aria-label="Quitar una unidad">−</button>' +
              '</div>' +



            '</div>'
          );

        }
      ).join('');

  }


  /* ========================================================
     UPDATE HEADER
  ======================================================== */

  /* 10% de bienvenida automático: en cuanto hay piezas en el carrito se aplica el código
     (Configuración del tema > CENIT · Categorías > Código de primera compra). Shopify lo conserva hasta el pago,
     así que también aparece aplicado en el checkout. Si el código no aplica (por ejemplo, ya se usó), no insiste. */
  var cenitWelcomeBusy = false;

  /* Contador real del 10%: arranca en la primera visita de cada persona, no se reinicia y al llegar a cero
     el código deja de aplicarse solo y se quita del carrito. Minutos: Configuración del tema > CENIT · Categorías. */
  function cenitWelcomeEndKey(){
    var box = document.getElementById('cenitCartDiscounts');
    return box ? 'cenitWelcomeEnd:' + (box.getAttribute('data-welcome-code') || '') : '';
  }
  function cenitWelcomeEnd(){
    try { return Number(localStorage.getItem(cenitWelcomeEndKey())) || 0; } catch(e){ return 0; }
  }
  function cenitWelcomeOver(){
    var box = document.getElementById('cenitCartDiscounts');
    if(!box || !(Number(box.getAttribute('data-welcome-min')) > 0)) return false;
    var end = cenitWelcomeEnd();
    return end > 0 && Date.now() >= end;
  }
  function cenitWelcomeExpire(){
    var box = document.getElementById('cenitCartDiscounts');
    var code = box ? String(box.getAttribute('data-welcome-code') || '') : '';
    cenitFetchCart().then(function(cart){
      var codes = (cart && cart.discount_codes) || [];
      var has = codes.some(function(c){ return String(c.code || '').toUpperCase() === code; });
      if(!has) return null;
      var rest = codes.map(function(c){ return c.code; }).filter(function(c){ return String(c).toUpperCase() !== code; }).join(',');
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: rest })
      }).then(function(){ return cenitFetchCart(); });
    }).then(function(fresh){
      if(fresh && window.cenitUpdateCartHeader) window.cenitUpdateCartHeader(fresh);
    }).catch(function(){});
  }
  function cenitInitWelcomeTimer(){
    var box = document.getElementById('cenitCartDiscounts');
    var minutes = box ? Number(box.getAttribute('data-welcome-min')) || 0 : 0;
    if(!minutes) return;
    var key = cenitWelcomeEndKey();
    var end = cenitWelcomeEnd();
    if(!end){
      end = Date.now() + minutes * 60000;
      try { localStorage.setItem(key, String(end)); } catch(e){ return; }
    }
    var els = document.querySelectorAll('[data-cenit-timer]');
    function paint(){
      var left = Math.ceil((end - Date.now()) / 1000);
      if(left <= 0){
        els.forEach(function(el){ el.hidden = true; });
        document.documentElement.classList.add('ce-10-over');
        clearInterval(timer);
        cenitWelcomeExpire();
        return;
      }
      var txt = Math.floor(left / 60) + ':' + (left % 60 < 10 ? '0' : '') + (left % 60);
      els.forEach(function(el){
        el.hidden = false;
        var out = el.querySelector('[data-cenit-timer-out]');
        if(out) out.textContent = txt;
      });
    }
    var timer = setInterval(paint, 1000);
    paint();
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cenitInitWelcomeTimer);
  else setTimeout(cenitInitWelcomeTimer, 0);
  function cenitEnsureWelcome(cart){
    var box = document.getElementById('cenitCartDiscounts');
    var code = box ? String(box.getAttribute('data-welcome-code') || '') : '';
    if(!code || cenitWelcomeBusy || !cart || !(Number(cart.item_count) > 0)) return;
    var codes = cart.discount_codes || [];
    var mine = codes.filter(function(c){ return String(c.code || '').toUpperCase() === code; })[0];
    if(mine) return;
    var KEY = 'cenitWelcomeSkip:' + code;
    try { if(sessionStorage.getItem(KEY) === '1') return; } catch(e){}
    if(cenitWelcomeOver()) return;
    cenitWelcomeBusy = true;
    var all = codes.map(function(c){ return c.code; }).concat(code).join(',');
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: all })
    })
      .then(function(r){ return r.json(); })
      .then(function(res){
        var got = (res.discount_codes || []).filter(function(c){ return String(c.code || '').toUpperCase() === code; })[0];
        if(!got || !got.applicable){ try { sessionStorage.setItem(KEY, '1'); } catch(e){} }
        return cenitFetchCart();
      })
      .then(function(fresh){
        cenitWelcomeBusy = false;
        if(fresh && window.cenitUpdateCartHeader) window.cenitUpdateCartHeader(fresh);
        document.dispatchEvent(new CustomEvent('cenit:welcome-applied', { detail: { cart: fresh } }));
      })
      .catch(function(){
        cenitWelcomeBusy = false;
        try { sessionStorage.setItem(KEY, '1'); } catch(e){}
      });
  }

  window.cenitUpdateCartHeader =
    function(cart){

      if(!cart){
        return;
      }

      cenitEnsureWelcome(cart);

      cenitRenderAccountCart(
        cart
      );


      cenitUpdateShippingProgress(
        cart
      );


      var cartLink =
        document.getElementById(
          'cenitHeaderCart'
        );


      var piecesText =
        cart.item_count === 1
          ? 'pieza'
          : 'piezas';


      if(cartLink){

        cartLink.innerHTML =
          '<div class="cenit-header__cart-icon" id="cenitHeaderCartIcon">' +

            '<svg viewBox="0 0 24 24">' +
              '<path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"></path>' +
              '<line x1="3" y1="6" x2="21" y2="6"></line>' +
              '<path d="M16 10a4 4 0 01-8 0"></path>' +
            '</svg>' +

            '<span class="cenit-header__account-badge' +
              (
                cart.item_count >
                0
                  ? ''
                  : ' is-empty'
              ) +
              '" id="cenitAccountCartBadge" aria-label="' +
              cart.item_count +
              ' productos en el carrito">' +
              cart.item_count +
            '</span>' +

          '</div>' +

          (
            cart.item_count >
            0
              ? '<div class="cenit-header__cart-info">' +
                  '<span class="cenit-header__cart-count">' +
                    cart.item_count +
                    ' ' +
                    piecesText +
                  '</span>' +

                  '<span class="cenit-header__cart-price">' +
                    cenitHeaderMoney(
                      cart.total_price
                    ) +
                  '</span>' +
                '</div>'

              : '<span class="cenit-header__cart-empty">Carrito</span>'
          );

      }


      var badge =
        document.getElementById(
          'cenitAccountCartBadge'
        );


      if(badge){

        badge.textContent =
          cart.item_count;


        badge.setAttribute(
          'aria-label',
          cart.item_count +
          ' productos en el carrito'
        );


        if(
          cart.item_count >
          0
        ){

          badge.classList.remove(
            'is-empty'
          );


          badge.classList.remove(
            'cenit-badge-pop'
          );


          void badge.offsetWidth;


          badge.classList.add(
            'cenit-badge-pop'
          );

        }else{

          badge.classList.add(
            'is-empty'
          );

        }

      }


      if(cartLink){

        cartLink.classList.remove(
          'cenit-cart-bump'
        );


        void cartLink.offsetWidth;


        cartLink.classList.add(
          'cenit-cart-bump'
        );


        setTimeout(
          function(){

            cartLink.classList.remove(
              'cenit-cart-bump'
            );

          },
          500
        );

      }

  };



  /* ========================================================
     UPDATE QUANTITY
  ======================================================== */

  function cenitChangeCartQuantity(key, quantity, shell){

    if(!key || !shell){
      return;
    }

    quantity = Math.max(0, Number(quantity) || 0);

    if(shell.dataset.updating === '1'){
      return;
    }

    shell.dataset.updating = '1';
    shell.style.opacity = '.65';

    fetch(
      cenitRoot() + 'cart/change.js',
      {
        method:'POST',
        headers:{
          'Content-Type':'application/json',
          'Accept':'application/json'
        },
        body:JSON.stringify({
          id:key,
          quantity:quantity
        })
      }
    )
    .then(function(response){

      if(!response.ok){
        throw new Error('No se pudo actualizar la cantidad.');
      }

      return response.json();

    })
    .then(function(cart){

      window.cenitUpdateCartHeader(cart);

      document.dispatchEvent(
        new CustomEvent(
          'cenit:cart-updated',
          {
            detail:{
              cart:cart
            }
          }
        )
      );

    })
    .catch(function(error){

      console.error(
        'CENIT: no se pudo actualizar la cantidad',
        error
      );

      shell.dataset.updating = '';
      shell.style.opacity = '';

    });

  }


  /* ========================================================
     REMOVE CART ITEM
  ======================================================== */

  function cenitRemoveCartItem(
    key,
    shell
  ){

    if(
      !key ||
      !shell ||
      shell.dataset.removing ===
      '1'
    ){
      return;
    }


    shell.dataset.removing =
      '1';


    shell.classList.add(
      'is-removing'
    );


    fetch(
      cenitRoot() +
      'cart/change.js',
      {
        method:'POST',
        headers:{
          'Content-Type':
            'application/json',
          'Accept':
            'application/json'
        },
        body:
          JSON.stringify({
            id:key,
            quantity:0
          })
      }
    )
    .then(
      function(response){

        if(!response.ok){

          throw new Error(
            'No se pudo quitar el producto.'
          );

        }

        return response.json();

      }
    )
    .then(
      function(cart){

        window.cenitUpdateCartHeader(
          cart
        );


        document.dispatchEvent(
          new CustomEvent(
            'cenit:cart-updated',
            {
              detail:{
                cart:cart
              }
            }
          )
        );

      }
    )
    .catch(
      function(error){

        console.error(
          'CENIT: no se pudo quitar el producto',
          error
        );


        shell.dataset.removing =
          '';


        shell.classList.remove(
          'is-removing'
        );


        var item =
          shell.querySelector(
            '.cenit-cart-drawer__item'
          );


        if(item){

          item.style.transform =
            '';

          item.style.transition =
            '';

        }

      }
    );

  }


  /* ========================================================
     REMOVE EVENTS + SWIPE
  ======================================================== */

  function cenitInitCartRemoval(){

    var itemsEl =
      document.getElementById(
        'cenitAccountCartItems'
      );


    if(
      !itemsEl ||
      itemsEl.dataset.removeReady ===
      '1'
    ){
      return;
    }


    itemsEl.dataset.removeReady =
      '1';


    itemsEl.addEventListener(
      'click',
      function(event){

        var qtyMinus =
          event.target.closest(
            '[data-cenit-qty-minus]'
          );

        var qtyPlus =
          event.target.closest(
            '[data-cenit-qty-plus]'
          );

        if(qtyMinus || qtyPlus){

          event.preventDefault();
          event.stopPropagation();

          var qtyShell =
            event.target.closest(
              '[data-cenit-cart-item]'
            );

          if(!qtyShell){
            return;
          }

          var qtyValueEl =
            qtyShell.querySelector(
              '[data-cenit-qty-value]'
            );

          var currentQty =
            qtyValueEl
              ? Number(qtyValueEl.textContent) || 0
              : 0;

          var nextQty =
            qtyPlus
              ? currentQty + 1
              : currentQty - 1;

          cenitChangeCartQuantity(
            qtyShell.dataset.cartKey,
            nextQty,
            qtyShell
          );

          return;
        }



        var itemLink =
          event.target.closest(
            '.cenit-cart-drawer__item'
          );


        if(itemLink){

          var itemShell =
            itemLink.closest(
              '[data-cenit-cart-item]'
            );


          if(
            itemShell &&
            itemShell.dataset.justSwiped ===
            '1'
          ){

            event.preventDefault();

            itemShell.dataset.justSwiped =
              '';

          }

        }

      }
    );


    var activeShell =
      null;

    var activeItem =
      null;

    var startX =
      0;

    var startY =
      0;

    var lastX =
      0;

    var horizontal =
      false;


    itemsEl.addEventListener(
      'touchstart',
      function(event){

        if(
          window.innerWidth >
          989 ||
          event.touches.length !==
          1
        ){
          return;
        }


        var item =
          event.target.closest(
            '.cenit-cart-drawer__item'
          );


        if(!item){
          return;
        }


        var shell =
          item.closest(
            '[data-cenit-cart-item]'
          );


        if(
          !shell ||
          shell.dataset.removing ===
          '1'
        ){
          return;
        }


        activeShell =
          shell;

        activeItem =
          item;

        startX =
          event.touches[0].clientX;

        startY =
          event.touches[0].clientY;

        lastX =
          startX;

        horizontal =
          false;


        activeItem.style.transition =
          'none';

      },
      {
        passive:true
      }
    );


    itemsEl.addEventListener(
      'touchmove',
      function(event){

        if(
          !activeShell ||
          !activeItem ||
          event.touches.length !==
          1
        ){
          return;
        }


        var x =
          event.touches[0].clientX;

        var y =
          event.touches[0].clientY;

        var dx =
          x -
          startX;

        var dy =
          y -
          startY;


        lastX =
          x;


        if(
          !horizontal &&
          Math.abs(dx) >
          8
        ){

          horizontal =
            Math.abs(dx) >
            Math.abs(dy);

        }


        if(!horizontal){
          return;
        }


        if(dx > 0){
          dx = 0;
        }


        dx =
          Math.max(
            dx,
            -105
          );


        event.preventDefault();


        activeItem.style.transform =
          'translate3d(' +
          dx +
          'px,0,0)';

      },
      {
        passive:false
      }
    );


    itemsEl.addEventListener(
      'touchend',
      function(){

        if(
          !activeShell ||
          !activeItem
        ){
          return;
        }


        var dx =
          lastX -
          startX;


        var shell =
          activeShell;


        var item =
          activeItem;


        item.style.transition =
          'transform .22s ease, opacity .22s ease';


        if(
          horizontal &&
          dx <=
          -62
        ){

          shell.dataset.justSwiped =
            '1';


          item.style.transform =
            'translate3d(-110%,0,0)';


          setTimeout(
            function(){

              cenitRemoveCartItem(
                shell.dataset.cartKey,
                shell
              );

            },
            150
          );

        }else{

          item.style.transform =
            '';

        }


        activeShell =
          null;

        activeItem =
          null;

        horizontal =
          false;

        startX =
          0;

        startY =
          0;

        lastX =
          0;

      },
      {
        passive:true
      }
    );


    itemsEl.addEventListener(
      'touchcancel',
      function(){

        if(activeItem){

          activeItem.style.transition =
            'transform .22s ease';

          activeItem.style.transform =
            '';

        }


        activeShell =
          null;

        activeItem =
          null;

        horizontal =
          false;

      },
      {
        passive:true
      }
    );

  }


  /* ========================================================
     FLY TO CART
  ======================================================== */

  window.cenitAnimateToCart =
    function(fallbackSource){

      var cart =
        document.getElementById(
          'cenitHeaderCart'
        );


      if(!cart){
        return;
      }


      var source =
        document.querySelector(
          '#cenitMainImg img.active'
        ) ||
        fallbackSource;


      if(!source){
        return;
      }


      var start =
        source.getBoundingClientRect();


      var end =
        cart.getBoundingClientRect();


      if(
        !start.width ||
        !start.height ||
        !end.width ||
        !end.height
      ){
        return;
      }


      var isImage =
        source.tagName &&
        source.tagName.toLowerCase() ===
        'img';


      var flyer =
        isImage
          ? source.cloneNode(
              true
            )
          : document.createElement(
              'div'
            );


      flyer.classList.add(
        'cenit-fly-to-cart'
      );


      var size =
        Math.max(
          38,
          Math.min(
            72,
            Math.min(
              start.width,
              start.height
            ) *
            .18
          )
        );


      var startX =
        start.left +
        start.width / 2 -
        size / 2;


      var startY =
        start.top +
        start.height / 2 -
        size / 2;


      var endX =
        end.left +
        end.width / 2 -
        size / 2;


      var endY =
        end.top +
        end.height / 2 -
        size / 2;


      flyer.style.left =
        startX +
        'px';

      flyer.style.top =
        startY +
        'px';

      flyer.style.width =
        size +
        'px';

      flyer.style.height =
        size +
        'px';


      if(!isImage){

        flyer.style.background =
          'var(--cenit-bronze)';

      }


      document.body.appendChild(
        flyer
      );


      var dx =
        endX -
        startX;


      var dy =
        endY -
        startY;


      var animation =
        flyer.animate(
          [
            {
              transform:
                'translate3d(0,0,0) scale(1)',
              opacity:1
            },
            {
              transform:
                'translate3d(' +
                dx * .55 +
                'px,' +
                (
                  dy * .45 -
                  45
                ) +
                'px,0) scale(.72)',
              opacity:.9,
              offset:.55
            },
            {
              transform:
                'translate3d(' +
                dx +
                'px,' +
                dy +
                'px,0) scale(.16)',
              opacity:.15
            }
          ],
          {
            duration:720,
            easing:
              'cubic-bezier(.22,.61,.36,1)',
            fill:'forwards'
          }
        );


      animation.onfinish =
        function(){

          flyer.remove();

        };

    };


  /* ========================================================
     INIT
  ======================================================== */

  cenitMountDrawer();

  cenitMountAccountMenu();

  cenitInitCartRemoval();

  cenitInitAnnouncements();

  cenitInitSearch();

  /* Si el carrito ya trae piezas sin el 10% de bienvenida, se aplica al cargar la página */
  (function(){
    var box = document.getElementById('cenitCartDiscounts');
    if(!box || box.getAttribute('data-welcome-needed') !== '1') return;
    cenitFetchCart().then(function(cart){ if(window.cenitUpdateCartHeader) window.cenitUpdateCartHeader(cart); }).catch(function(){});
  })();

  document.addEventListener(
    'shopify:section:load',
    function(){

      setTimeout(
        cenitMountDrawer,
        0
      );

      setTimeout(
        cenitMountAccountMenu,
        0
      );

      setTimeout(
        cenitInitCartRemoval,
        0
      );

      setTimeout(
        cenitInitAnnouncements,
        0
      );

      setTimeout(
        cenitInitSearch,
        0
      );


      setTimeout(
        function(){

          cenitFetchCart()
          .then(
            cenitUpdateShippingProgress
          )
          .catch(
            function(){}
          );

        },
        0
      );

    }
  );


  document.addEventListener(
    'click',
    function(event){

      var checkout =
        event.target.closest &&
        event.target.closest(
          '#cenitAccountCheckout.is-disabled'
        );


      if(checkout){

        event.preventDefault();

      }

    }
  );


  document.addEventListener(
    'keydown',
    function(event){

      if(
        event.key ===
        'Escape'
      ){

        window.cenitCloseDrawer();

        window.cenitCloseAccountMenu();

        window.cenitCloseSearch();

      }

    }
  );


  document.addEventListener(
    'cenit:cart-updated',
    function(event){

      if(
        event.detail &&
        event.detail.cart
      ){

        window.cenitUpdateCartHeader(
          event.detail.cart
        );

      }else{

        cenitFetchCart()
        .then(
          window.cenitUpdateCartHeader
        )
        .catch(
          function(){}
        );

      }

    }
  );

})();

/* Contador de fin de promos (Configuración del tema > CENIT · Categorías > Contador).
   Fecha en hora del centro de México (UTC-6). Al terminar, el aviso desaparece. */
(function(){
  var els = document.querySelectorAll('[data-cenit-countdown]');
  if(!els.length) return;
  function parse(str){
    var m = String(str).match(/(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);
    if(!m) return NaN;
    return Date.UTC(+m[1], +m[2] - 1, +m[3], (m[4] ? +m[4] : 23) + 6, m[5] ? +m[5] : 59);
  }
  function pad(n){ return n < 10 ? '0' + n : '' + n; }
  function tick(){
    var alive = false;
    els.forEach(function(el){
      var end = parse(el.getAttribute('data-cenit-countdown'));
      var left = end - Date.now();
      if(isNaN(end) || left <= 0){ el.remove(); return; }
      alive = true;
      var s = Math.floor(left / 1000);
      var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), mi = Math.floor(s % 3600 / 60), se = s % 60;
      var out = el.querySelector('[data-cenit-countdown-out]');
      if(out) out.textContent = (d ? d + (d === 1 ? ' día ' : ' días ') : '') + pad(h) + ':' + pad(mi) + ':' + pad(se);
    });
    if(alive) setTimeout(tick, 1000);
  }
  tick();
})();

